import { FormKeys } from '.';

export interface FormFields {
    [FormKeys.PackName]: string;
    [FormKeys.Description]: string;
    [FormKeys.LabelName]: string;
    [FormKeys.Genre]: string;
    [FormKeys.Subgenre]: string;
    [FormKeys.GenreOptional]: string;
    [FormKeys.SubgenreOptional]: string;
    [FormKeys.Exclusivity]: string;
    [FormKeys.Lexicon]: string;
}
